import { isDateSame, isDateSameOrAfter, isDateSameOrBefore } from 'odfjell-date-time-utils/dateTimeUtils';
import { ValidatedNoonReport } from 'src/types/ViewModel/ValidatedNoonReport';
import { isNullOrUndefined } from 'src/utils/objectUtils';
import { ValidatedNoonReportFactory } from '../ValidatedNoonReportFactory';
import { GetSection } from 'src/utils/aolSectionHelper';
import { convertToDate } from 'odfjell-date-time-utils/dateTimeConverter';
import { DateTimeFormat } from 'odfjell-date-time-utils/dateTimeFormatter';

export const mapOfflineAolItemsForNewReports = (offlineAolItems: any[], fromDate: Date, toDate: Date) => {
    const validatedNoonReportFactory = new ValidatedNoonReportFactory();

    return offlineAolItems
        .filter((a) => a.noonReportId < 0)
        .map((offlineAolItem) => {
            const noonReport = validatedNoonReportFactory.createNewOfflineReport(offlineAolItem.addNoonReportRequest.response);

            offlineAolItem.saveNoonReportSectionRequests.forEach((saveNoonReportSectionRequest) => {
                validatedNoonReportFactory.updateOfflineReport(noonReport, saveNoonReportSectionRequest.response);
            });
            updateSectionStatuses(offlineAolItem, noonReport);

            return noonReport;
        })
        .filter((n) => {
            const noonReportDate = convertToDate(n.generalSection.noonReportDateTime.aolDateLocalTime, DateTimeFormat.queryFormats.dateOnly);
            return isDateSameOrAfter(noonReportDate, fromDate, 'day') && isDateSameOrBefore(noonReportDate, toDate, 'day');
        });
};

export const mapOfflineNoonReports = (
    offlineAolItems: any[],
    offlineNoonReports: ValidatedNoonReport[],
    noonReports: ValidatedNoonReport[],
    fromDate: Date,
    toDate: Date
) => {
    const offlineAolItemsForExistingReports = offlineAolItems.filter((a) => a.noonReportId > 0);
    const validatedNoonReportFactory = new ValidatedNoonReportFactory();
    const deletedNoonReports = offlineAolItemsForExistingReports.filter((n) => n.deleteNoonReportRequest);

    noonReports = noonReports.filter((n) => !deletedNoonReports.some((d) => n.metadata.noonReportId === +d.noonReportId));

    offlineNoonReports.forEach((offlineNoonReport) => {
        const indexOfReport = findIndexOfNoonReportByTime(
            noonReports,
            offlineNoonReport.generalSection.noonReportDateTime.reportFromTimeLocalTime,
            offlineNoonReport.generalSection.noonReportDateTime.reportToTimeLocalTime
        );

        if (indexOfReport > -1) {
            noonReports[indexOfReport] = offlineNoonReport;
        } else {
            noonReports.push(offlineNoonReport);
        }
    });

    noonReports = noonReports.filter((n) => !isNullOrUndefined(n));
    noonReports.forEach((noonReport) => {
        const offlineAolItem = offlineAolItemsForExistingReports.find((p) => p.noonReportId === noonReport.metadata.noonReportId);
        if (offlineAolItem?.saveNoonReportSectionRequests) {
            offlineAolItem.saveNoonReportSectionRequests.forEach((saveNoonReportSectionRequest) => {
                validatedNoonReportFactory.updateOfflineReport(noonReport, saveNoonReportSectionRequest.response);
            });

            updateSectionStatuses(offlineAolItem, noonReport);
        }
    });

    return noonReports.filter((n) => {
        const noonReportDate = convertToDate(n.generalSection.noonReportDateTime.aolDateLocalTime, DateTimeFormat.queryFormats.dateOnly);
        return isDateSameOrAfter(noonReportDate, fromDate, 'day') && isDateSameOrBefore(noonReportDate, toDate, 'day');
    });
};

export const updateSectionStatuses = (aolStoreItem, noonReport: ValidatedNoonReport) => {
    if (aolStoreItem.updateSectionStatusRequests) {
        aolStoreItem.updateSectionStatusRequests.forEach((updateSectionStatusRequest) => {
            const section = GetSection(+updateSectionStatusRequest.response.noonReportSectionEnum, noonReport);

            if (section?.sectionData) {
                section.sectionData.isApproved = updateSectionStatusRequest.response.isSectionApproved;
                section.sectionData.isCompleted = updateSectionStatusRequest.response.isSectionCompleted;
            }
        });
    }
};

const findIndexOfNoonReportByTime = (noonReports: ValidatedNoonReport[], startTime: Date, stopTime: Date) =>
    noonReports.findIndex(
        (n) =>
            isDateSame(n.generalSection.noonReportDateTime.reportFromTimeLocalTime, startTime, 'minute') &&
            isDateSame(n.generalSection.noonReportDateTime.reportToTimeLocalTime, stopTime, 'minute')
    );
